/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "d1ea26e66ae05906272ab0f63c1981b58b2ef2f7";
